export default __webpack_public_path__ + "0e567f40c177139bf72d4e15518b93ed.png";